import {
    Box,
    Button,
    List,
    ListItem,
    Paper,
    Stack,
    Typography,
} from "@mui/material";
import React from "react";
import styles from "../../styles/pages/mymessagePurchasedRequest.module.scss";
// import Image from "next/image";
import assest from "../../json/assest";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";

const attachFileLoop = [
    {
        fileName: "5028537_5563370603774986_243130120555181753_n.jpg",
    },
    {
        fileName: "5028537_5563370603774986.png",
    },
    {
        fileName: "5028537_5563370603774986_2431301205551817se_522gfjgdstAjdfdfgfvc556254dz52d",
    },
    {
        fileName: "5028537_5563370603774986_243130120555181753_n.jpg",
    },
]

const ContentbuyerPurchaserequestAttachfiles = ({ showAttachFiles }) => {
    return (
        <>
            <Box className={styles.msgdetails}>
                <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="space-between"
                    flexWrap="wrap"
                    className={styles.detailsTopHeading}
                >
                    <Typography variant="h3" className={styles.headingStyled}>
                        Attached Files
                    </Typography>
                </Stack>
                <Paper className={`${styles.styledPaper} ${styles.attachFilePaper}`}>
                    <PerfectScrollbar
                        className={`${styles.showAttachFile} ${styles.forScroll}`}
                    >
                        <List>
                            {attachFileLoop.map((item, index) => {
                                return (
                                    <ListItem key={index}>
                                        <img src={assest.IconDwnarw} width={14} height={14} alt='icon' />
                                        <Typography variant='caption'>{item?.fileName}</Typography>
                                    </ListItem>
                                );
                            })}
                        </List>
                    </PerfectScrollbar>
                </Paper>
                {showAttachFiles &&
                    <Paper
                        className={`${styles.styledPaper} ${styles.noAttachFile}`}
                    >
                        <img
                            src={assest.IconNofile}
                            width={44}
                            height={44}
                            alt="icon"
                        />
                        <Typography variant="caption">
                            All files that will be uploaded will be displayed in
                            this section
                        </Typography>
                    </Paper>
                }
            </Box>
        </>
    )
}

export default ContentbuyerPurchaserequestAttachfiles